import React, { Component } from 'react';
import partial from 'lodash/partial';
import { Field } from 'redux-form';
import { CheckBoxField } from 'common/components/form_fields';
import Money from 'common/components/money';

export default class FeaturesField extends Component {
  constructor(props) {
    super(props);

    this.toggleActive = this.toggleActive.bind(this);
    this.toggleRefund = this.toggleRefund.bind(this);
  }

  toggleActive(active, feature, e) {
    const { checked } = e.target;
    const { input: { value, onChange } } = this.props;
    let newValue = value;

    if (checked) {
      /* remove all feature from the same group first */
      if (feature.group) {
        newValue = newValue.filter(item => item.feature_group !== feature.group);
      }
      newValue = newValue.concat({
        feature_id: feature.id,
        active: active,
        issue_discount: false,
        feature_group: feature.group
      });
    } else {
      newValue = newValue.filter(item => item.feature_id !== feature.id);
    }

    onChange(newValue);
  }

  toggleRefund(feature, e) {
    const refund = e.target.checked;
    const { input: { value, onChange } } = this.props;
    const newValue = value.map(item => {
      if (item.feature_id === feature.id) {
        return { ...item, issue_discount: refund };
      }
      return item;
    });
    onChange(newValue);
  }

  render() {
    const { features, input: { value } } = this.props;

    return (
      <div className="features-field">
        <table className="table table-default">
          <thead>
            <tr>
              <td>Active</td>
              <td>Name</td>
              <td>Price</td>
              <td>Deactivate</td>
              <td>Activate</td>
              <td>Issue Discount</td>
            </tr>
          </thead>
          <tbody>
            { features.map((feature, i) => {
                const featureValues = value.find(item => item.feature_id === feature.id) || {};
                /* don't allow this feature to be deactivated because that's our default and it
                   would only cause confusion */
                const is7DayFeature = feature.name === '7 day project';

                return (
                  <tr key={i}>
                    <td className="text-center">
                      { feature.active && <i className="fa fa-check" /> }
                    </td>
                    <td>{ feature.name }</td>
                    <td>{ feature.price > 0? <Money value={feature.price} /> : 'FREE' }</td>
                    <td>
                      { feature.active && !is7DayFeature?
                      <input type="checkbox" checked={featureValues.active === false}
                        onChange={partial(this.toggleActive, false, feature)} /> : '-' }
                    </td>
                    <td>
                      { !feature.active?
                      <input type="checkbox" checked={!!featureValues.active}
                        onChange={partial(this.toggleActive, true, feature)} /> : '-' }
                    </td>
                    <td>
                      { featureValues.active && feature.price > 0?
                      <input type="checkbox" checked={!!featureValues.issue_discount}
                        onChange={partial(this.toggleRefund, feature)} /> : '-' }
                    </td>
                  </tr>
                );
              }) }
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./admin/components/features_field.jsx